var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadAsset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 159.5,
    height: 92.544,
    viewBox: "0 0 159.5 92.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_14253",
    x: 41.948,
    y: 38.392,
    width: 64.967,
    height: 54.152,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_220073",
    "data-name": "Group 220073",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164880",
    "data-name": "Group 164880"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_509",
    "data-name": "Line 509",
    x2: 24.169,
    transform: "translate(133.831 81.181)",
    fill: "none",
    stroke: "#929193",
    strokeLinecap: "round",
    strokeWidth: 3,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14251",
    "data-name": "Path 14251",
    d: "M479.39,107.372a6.826,6.826,0,0,0,1.536,4.394,4.891,4.891,0,0,0,3.716,1.821h24.731a4.88,4.88,0,0,1,3.716,1.821,6.867,6.867,0,0,1,1.536,4.4,6.107,6.107,0,0,1-3.938,6.022,4.369,4.369,0,0,1-1.315.2H492.48a6.106,6.106,0,0,0-3.938,6.022,6.828,6.828,0,0,0,1.536,4.4,5.01,5.01,0,0,0,2.4,1.619H517a4.37,4.37,0,0,1,1.307.2,5.158,5.158,0,0,1,2.408,1.619,6.853,6.853,0,0,1,1.536,4.4c0,3.431-2.357,6.223-5.252,6.223H503.611c-2.9,0-5.245,2.783-5.245,6.214a6.829,6.829,0,0,0,1.536,4.4,4.848,4.848,0,0,0,3.708,1.82H623.2c2.9,0,5.252-2.783,5.252-6.223a6.792,6.792,0,0,0-1.544-4.394,4.866,4.866,0,0,0-3.708-1.821h-25.07a4.864,4.864,0,0,1-3.708-1.821,6.831,6.831,0,0,1-1.544-4.4,6.113,6.113,0,0,1,3.945-6.022,4.371,4.371,0,0,1,1.307-.2h16.554a6.111,6.111,0,0,0,3.945-6.022,6.824,6.824,0,0,0-1.536-4.4,5.034,5.034,0,0,0-2.408-1.619H597.452a4.372,4.372,0,0,1-1.315-.2,5.14,5.14,0,0,1-2.4-1.619,6.852,6.852,0,0,1-1.536-4.4c0-3.431,2.349-6.223,5.252-6.223h26.425c2.9,0,5.245-2.783,5.245-6.214a6.866,6.866,0,0,0-1.536-4.4,4.839,4.839,0,0,0-3.708-1.821H484.642C481.746,101.15,479.39,103.933,479.39,107.372Z",
    transform: "translate(-479.389 -93.117)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_506",
    "data-name": "Line 506",
    x2: 7.513,
    transform: "translate(2.098 81.486)",
    fill: "none",
    stroke: "#929193",
    strokeLinecap: "round",
    strokeWidth: 3,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_507",
    "data-name": "Line 507",
    x2: 13.28,
    transform: "translate(15.861 81.425)",
    fill: "none",
    stroke: "#929193",
    strokeLinecap: "round",
    strokeWidth: 3,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_508",
    "data-name": "Line 508",
    d: "M0,0H91.087",
    transform: "translate(35.923 81.425)",
    fill: "none",
    stroke: "#929193",
    strokeLinecap: "round",
    strokeWidth: 3,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_511",
    "data-name": "Line 511",
    x2: 51.813,
    transform: "translate(49.875 87.675)",
    fill: "none",
    stroke: "#929193",
    strokeLinecap: "round",
    strokeWidth: 3,
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_14253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14253-2",
    "data-name": "Path 14253",
    d: "M574.41,160.306s-3.964-.2-4.137,4.27-.5,28.886-.5,28.886a2.172,2.172,0,0,0,2.311,2.722c2.878.021,36.784.239,36.784.239l7.827-25.928s0-4.463-5.629-4.634-20.788-.108-20.788-.108-1.9.762-3.028-1.623-1.454-3.762-2.582-3.83S574.41,160.306,574.41,160.306Z",
    transform: "translate(-518.77 -115.88)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_14254",
    "data-name": "Path 14254",
    d: "M577.373,205.362l5.161-20.037s.734-3.077,3.075-3.235,33.993.452,33.993.452,3.7-.155,2.721,3.311-5.1,18.739-5.1,18.739,0,3.884-4.467,3.881-37.762-.242-37.762-.242S576.671,208.089,577.373,205.362Z",
    transform: "translate(-521.687 -127.927)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14255",
    "data-name": "Path 14255",
    d: "M583.723,155.395l1.216-2.85a1.994,1.994,0,0,1,2.562-.87,1.908,1.908,0,0,1,1.034,2.467l-1.567,3.672s-.547,1.089-1.359.763-.466-1.5-.466-1.5l1.157-2.71",
    transform: "translate(-526.514 -111.023)",
    fill: "none",
    stroke: "#ccc",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5488",
    "data-name": "Group 5488",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 46.28, 2.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14262",
    "data-name": "Path 14262",
    d: "M0,4.475,7.6,31.3l18.965-5.374s2.618-.946,1.622-4.321-4.958-17.5-4.958-17.5L15.866,0Z",
    transform: "translate(0 0)",
    fill: "#c6c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14263",
    "data-name": "Path 14263",
    d: "M0,5.161S1.5,8.6,3.986,7.893L22.273,2.711A3.657,3.657,0,0,1,18.212,0Z",
    transform: "translate(3.354 23.486)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14264",
    "data-name": "Path 14264",
    d: "M0,0,1.594,5.625,7.332,4Z",
    transform: "translate(15.866 0)",
    fill: "#efeeee"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_520",
    "data-name": "Line 520",
    y1: 3.551,
    x2: 12.53,
    transform: "translate(6.908 8.52)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_521",
    "data-name": "Line 521",
    y1: 2.666,
    x2: 9.407,
    transform: "translate(7.9 12.904)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_522",
    "data-name": "Line 522",
    y1: 2.324,
    x2: 8.203,
    transform: "translate(8.838 16.557)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_523",
    "data-name": "Line 523",
    y1: 1.813,
    x2: 6.397,
    transform: "translate(9.777 20.38)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_37",
    "data-name": "Ellipse 37",
    cx: 6.772,
    cy: 6.772,
    r: 6.772,
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 89.15, 24.455)",
    fill: "#ffb413"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5486",
    "data-name": "Group 5486",
    transform: "matrix(0.995, -0.105, 0.105, 0.995, 78.715, 18.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14256",
    "data-name": "Path 14256",
    d: "M12.518,0,0,17.7l12.508,8.849s1.85,1.122,3.405-1.129,8.164-11.541,8.164-11.541L22.97,7.413Z",
    transform: "translate(0.986 0)",
    fill: "#c6c3c3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14257",
    "data-name": "Path 14257",
    d: "M.52,0S-.825,2.586.812,3.745l12.062,8.533a2.843,2.843,0,0,1-.342-3.78Z",
    transform: "translate(0 13.828)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14258",
    "data-name": "Path 14258",
    d: "M2.625,0,0,3.71,3.785,6.388Z",
    transform: "translate(21.332 7.413)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_512",
    "data-name": "Line 512",
    x2: 8.265,
    y2: 5.846,
    transform: "translate(12.282 7.887)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_513",
    "data-name": "Line 513",
    x2: 6.205,
    y2: 4.389,
    transform: "translate(10.649 10.195)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_514",
    "data-name": "Line 514",
    x2: 5.41,
    y2: 3.827,
    transform: "translate(9.104 12.379)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_515",
    "data-name": "Line 515",
    x2: 4.219,
    y2: 2.985,
    transform: "translate(7.559 14.563)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAsset);
export default __webpack_public_path__ + "static/media/upload_asset.40fa41351d0f8512324f7a93010f3be1.svg";
export { ForwardRef as ReactComponent };